import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const HeaderResponsive = () => {
    return (
        <div id="header-responsive">
            <div id="header-responsive-menu" className="header-responsive position-fixed xp-4">
                <div className="title-header-responsive d-flex align-items-center xmb-4">
                    <div id="close-burger-menu" className="icon-close xml-4">
                        <IconName name="expand_close" className="icon"/>
                    </div>
                    <div className="logo">
                        <a href="#">
                            <IconName name="sayman-logo"/>
                        </a>
                    </div>
                </div>
                <div className="list-links-responsive">
                    <ul className="list-unstyled">
                        <li className="position-relative">
                            <div id="product-link-responsive">
                            <span id="close-dropdown-link-responsive" className="icon-add position-absolute">
                                <IconName name="add" className="icon"/>
                            </span>
                                <a href="#">
                                    <IconName name="products" className="icon"/>
                                    محصولات
                                </a>
                            </div>
                            <ul id="child-header-nav-responsive" className="list-unstyled">
                                <li><Link to="/products">
                                    <IconName name="phone" className="icon"/>
                                    گوشی موبایل
                                </Link></li>
                                <li><a href="#">
                                    <IconName name="laptop" className="icon"/>
                                    تبلت و لپ تاپ
                                </a></li>
                                <li><a href="#">
                                    <IconName name="watch" className="icon"/>
                                    ساعت هوشمند
                                </a></li>
                                <li><a href="#">
                                    <IconName name="home" className="icon"/>
                                    خانه هوشمند
                                </a></li>
                                <li><a href="#">
                                    <IconName name="tv" className="icon"/>
                                    تلوزیون هوشمند
                                </a></li>
                                <li><a href="#">
                                    <IconName name="controller" className="icon"/>
                                    کنسول بازی
                                </a></li>
                                <li><a href="#">
                                    <IconName name="battery_charging_full" className="icon"/>
                                    پاور بانک
                                </a></li>
                                <li><a href="#">
                                    <IconName name="cable" className="icon"/>
                                    لوازم جانبی
                                </a></li>
                            </ul>
                        </li>
                        <li><a href="#">
                            <IconName name="blog" className="icon"/>
                            وب لاگ
                        </a></li>
                        <li><Link to="/vendorHomePage">
                            <IconName name="vendor" className="icon"/>
                            فروشنده شوید
                        </Link></li>
                        <li><a href="#">
                            <IconName name="help_outline" className="icon"/>
                            پرسش های متداول
                        </a></li>
                        <li><a href="#">
                            <IconName name="question_answer" className="icon"/>
                            بازخورد شما
                        </a></li>
                        <li><a href="#">
                            <IconName name="support_agent" className="icon"/>
                            تماس با ما
                        </a></li>
                    </ul>
                </div>
                <div className="social-media d-flex justify-content-center align-content-center xmt-12">
                    <a href="#"><IconName name="telegram" className="icon"/></a>
                    <a href="#"><IconName name="instagram" className='icon'/></a>
                    <a href="#"><IconName name="youtube" className="icon"/></a>
                    <a href="#"><IconName name="aparat" className="icon"/></a>
                </div>
            </div>
        </div>
    );
};

export default HeaderResponsive;
